/**
 * The LpHeroFullsize component
 */
import React from "react";
import PropTypes from "prop-types";
import { Container, Row, Col } from "reactstrap";
import Perks from "../../../components/Perks";
import CMSBlock from "../../../components/CMSBlock";
import ShopProductCard from "../../../components/ShopProductCard";
import { Link } from "react-router-dom";
import ResponsivePicture from "../../ResponsivePicture";
import LazyLoad from "react-lazyload";

import filter from "lodash/filter";

// FIXME enforce CMSBlockTeaser Layout
import CMSBlockTeaser from "../../../components/CMSBlock/utils/CMSBlockTeaser";

const _ = {
  filter: filter,
};

/**
 * Stateless react component to render the LpHeroFullsize component
 * @param {Object} props the props passed to the page.
 */
const LpHeroFullsize = (props, context) => {
  const { landingpage, navigateTo, cmsBlock1, productTeasers } = props;
  const language = "de";
  let lp = {};
  const widgetConfiguration = JSON.parse(landingpage.widget_configuration);
  if (widgetConfiguration) {
    lp.products = widgetConfiguration ? widgetConfiguration.products : false;
    lp.categories = widgetConfiguration
      ? widgetConfiguration.categories
      : false;
    lp.category_style = widgetConfiguration
      ? widgetConfiguration.category_style
      : "topbar";
  }

  const productBlocks = _.filter(productTeasers, function (cmsBlock) {
    return (
      cmsBlock.slug.startsWith("overview_product_") ||
      cmsBlock.slug.startsWith("product_") ||
      cmsBlock.slug.startsWith("home_teaser_") ||
      cmsBlock.slug.startsWith("home_product_")
    );
  });

  const contentBlocks = _.filter(productTeasers, function (cmsBlock) {
    return (
      !cmsBlock.slug.startsWith("overview_product_") &&
      !cmsBlock.slug.startsWith("product_") &&
      !cmsBlock.slug.startsWith("home_teaser_") &&
      !cmsBlock.slug.startsWith("home_product_")
    );
  });
  return (
    <div className="lp-hero-fullsize">
      <div className="hero container">
        <div className="hero__bg">
          <ResponsivePicture
            mediumData={{
              sources: landingpage.hero_image,
              metadata: {
                width: "100%",
                height: "100%",
              },
            }}
            cover
            altTitle={landingpage.title}
          />
        </div>
        <header className="col-lg-5 col-md-12 p-3 bg-white pull-left mt-5 rounded shadow">
          {landingpage.title && (
            <h1 style={{ position: "relative" }}>{landingpage.title}</h1>
          )}
          {cmsBlock1 && cmsBlock1[0] && <CMSBlock cmsBlock={cmsBlock1[0]} />}
        </header>
      </div>
      {!!lp.categories && lp.category_style && (
        <Container className="p-2 category-topbar">
          <div className="d-flex flex-wrap justify-content-between">
            {lp.categories.map((category) => (
              <div className="flex-grow-1 text-center small">
                {!!category.external && (
                  <a href={category.external} className="h6 semi-small">
                    <LazyLoad>
                      <ResponsivePicture
                        mediumData={{
                          url: `${category.thumbnail_png} 640w`,
                          metadata: {
                            width: 60,
                            height: 60,
                          },
                        }}
                        className="category-topbar-img rounded"
                        altTitle={category.title}
                      />
                      {/* <Picture
                        className="category-topbar-img rounded"
                        sources={[
                          {
                            srcSet: `${category.thumbnail_png} 640w`,
                            type: "image/jpeg",
                          },
                        ]}
                        sizes="(min-width: 87.5em) calc(466.66px - 30px),(min-width: 75em) calc(33.33vw - 30px), (min-width: 62em) calc(360px - 30px), (min-width: 48em) calc(540px - 30px), (min-width: 36em) calc(100vw - 30px)"
                        alt={category.title}
                        loading="lazy"
                      /> */}
                    </LazyLoad>
                    <br />
                    {category.title}
                  </a>
                )}
                {!category.external && (
                  <Link
                    to={
                      category.internal
                        ? category.internal
                        : `/${language}/c/${category.id}/`
                    }
                    className="h6 semi-small"
                  >
                    <LazyLoad>
                      <ResponsivePicture
                        mediumData={{
                          url: `${category.thumbnail_png} 640w`,
                          metadata: {
                            width: 60,
                            height: 60,
                          },
                        }}
                        className="category-topbar-img rounded"
                        altTitle={category.title}
                      />
                      {/* <Picture
                        className="category-topbar-img rounded"
                        sources={[
                          {
                            srcSet: `${category.thumbnail_png} 640w`,
                            type: "image/jpeg",
                          },
                        ]}
                        sizes="(min-width: 87.5em) calc(466.66px - 30px),(min-width: 75em) calc(33.33vw - 30px), (min-width: 62em) calc(360px - 30px), (min-width: 48em) calc(540px - 30px), (min-width: 36em) calc(100vw - 30px)"
                        alt={category.title}
                        loading="lazy"
                      /> */}
                    </LazyLoad>
                    <br />
                    {category.title}
                  </Link>
                )}
              </div>
            ))}
          </div>
        </Container>
      )}
      <Container className="my-3">
        {landingpage.subtitle && <h2>{landingpage.subtitle}</h2>}
        {productBlocks && (
          <Row>
            {productBlocks?.map((block) => (
              <Col xl={3} md={6} key={block.id}>
                <CMSBlockTeaser
                  key={`home_cms_block_${block.id}`}
                  cmsBlock={block}
                />
              </Col>
            ))}
          </Row>
        )}
        {landingpage.intro && (
          <div dangerouslySetInnerHTML={{ __html: landingpage.intro }} />
        )}
      </Container>

      {lp.products &&
        lp.products.map((category) => (
          <Container className="my-5">
            <h3 className="h5">{category.title}</h3>
            <Row>
              {category.products &&
                category.products.map((product) => (
                  <Col xl={2} lg={4} xs={6} className="mb-3">
                    <ShopProductCard
                      product={product}
                      language={language}
                      navigateTo={navigateTo}
                    />
                  </Col>
                ))}
            </Row>
            {!!category.external && (
              <a href={category.external} className="pull-right">
                {context.t("view all products")}
              </a>
            )}
            {!category.external && category.id && (
              <Link
                to={`/${language}/c/${category.id}/`}
                className="pull-right"
              >
                {context.t("view all products")}
              </Link>
            )}
          </Container>
        ))}
      <Perks />
      <Container className="my-5">
        {landingpage.content && (
          <div dangerouslySetInnerHTML={{ __html: landingpage.content }} />
        )}
      </Container>

      {contentBlocks?.map((cmsBlock, idx) => {
        return (
          <>
            <Container
              key={"cmsblock-" + idx}
              className={"my-5 py-3" + (idx % 3 ? "" : " bg-light")}
            >
              <CMSBlock cmsBlock={cmsBlock} invert={idx % 2} />
            </Container>
          </>
        );
      })}
    </div>
  );
};

/** define proptypes for the form */
LpHeroFullsize.propTypes = {
  /** the item */
  landingpage: PropTypes.object.isRequired,
};

/**  define proptype for the 'translation' function  */
LpHeroFullsize.contextTypes = {
  t: PropTypes.func,
};
export default LpHeroFullsize;
